<template>
  <div>
    <v-container>
      <v-card>
        <v-container>
          <v-card-title>Create Paste</v-card-title>
          <v-text-field
            class="rounded-xl"
            v-model="paste.name"
            counter="50"
            maxlength="50"
            placeholder="Name"
          ></v-text-field>
          <v-textarea
            v-model="paste.content"
            :placeholder="'function test() {\n console.log(\'hello\')\n}'"
            counter="50000"
            maxlength="50000"
          >
          </v-textarea>
          <v-autocomplete
            v-model="paste.selectedHighlight"
            :items="highlighters"
            color="white"
            item-text="name"
            item-value="internalName"
            label="Syntax Highlighting"
          >
          </v-autocomplete>
          <v-btn class="rounded-xl" :loading="loading" @click="createPaste()"
            >Create</v-btn
          >
          <v-card-title>Preview</v-card-title>
          <highlightjs
            v-if="
              paste.selectedHighlight !== 'none' &&
              paste.selectedHighlight !== 'auto'
            "
            :code="paste.content"
            :language="paste.selectedHighlight"
            class="text-left padding"
          />
          <highlightjs
            v-if="paste.selectedHighlight === 'auto'"
            :code="paste.content"
            autodetect
            class="text-left padding"
          />
          <highlightjs
            v-if="paste.selectedHighlight === 'none'"
            :code="paste.content"
            class="text-left padding"
          />
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "PastesCreate",
  data() {
    return {
      loading: false,
      paste: {
        name: "",
        selectedHighlight: "auto",
        content: ""
      },
      highlighters: [
        {
          name: "Automatic",
          internalName: "auto"
        },
        {
          name: "None",
          internalName: "plaintext"
        },
        {
          name: "Bash",
          internalName: "bash"
        },
        {
          name: "C",
          internalName: "c"
        },
        {
          name: "C#",
          internalName: "csharp"
        },
        {
          name: "C++",
          internalName: "cpp"
        },
        {
          name: "CSS",
          internalName: "css"
        },
        {
          name: "Diff",
          internalName: "diff"
        },
        {
          name: "Go",
          internalName: "go"
        },
        {
          name: "XML",
          internalName: "xml"
        },
        {
          name: "JSON",
          internalName: "json"
        },
        {
          name: "Java",
          internalName: "java"
        },
        {
          name: "JavaScript",
          internalName: "javascript"
        },
        {
          name: "Kotlin",
          internalName: "kotlin"
        },
        {
          name: "Less",
          internalName: "less"
        },
        {
          name: "Lua",
          internalName: "lua"
        },
        {
          name: "Makefile",
          internalName: "makefile"
        },
        {
          name: "Markdown",
          internalName: "markdown"
        },
        {
          name: "ObjectiveC",
          internalName: "objectivec"
        },
        {
          name: "PHP",
          internalName: "php"
        },
        {
          name: "PHP Template",
          internalName: "php-template"
        },
        {
          name: "Perl",
          internalName: "perl"
        },
        {
          name: "Plaintext",
          internalName: "plaintext"
        },
        {
          name: "Python",
          internalName: "python"
        },
        {
          name: "Python REPL",
          internalName: "python-repl"
        },
        {
          name: "R",
          internalName: "r"
        },
        {
          name: "Ruby",
          internalName: "ruby"
        },
        {
          name: "Rust",
          internalName: "rust"
        },
        {
          name: "SCSS",
          internalName: "scss"
        },
        {
          name: "SQL",
          internalName: "sql"
        },
        {
          name: "Shell",
          internalName: "shell"
        },
        {
          name: "Swift",
          internalName: "swift"
        },
        {
          name: "INI",
          internalName: "ini"
        },
        {
          name: "TypeScript",
          internalName: "typescript"
        },
        {
          name: "Visual Basic",
          internalName: "vbnet"
        },
        {
          name: "YAML",
          internalName: "yaml"
        }
      ]
    }
  },
  methods: {
    createPaste() {
      this.loading = true
      this.axios
        .post("/api/v1/gallery/paste", {
          ...this.paste
        })
        .then((res) => {
          this.$router.push("/" + res.data.attachment)
          this.$toast("Your paste has been created.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    }
  }
}
</script>

<style scoped></style>
